<template>
  <div id="services">
    <hr />
    <mdb-container>
      <div class="row">
        <div class="col-12 p-5">
          <h1>Servicios</h1>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-6 mt-2">
          <mdb-flipping-card
            :flipped="flipped_1"
            innerClass="text-center h-100 w-100"
            style="height: 416px;"
          >
            <mdb-card class="face front" style="height: 416px;">
              <mdb-avatar class="mx-auto white mt-4" circle>
                <!-- <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(20).jpg" class="rounded-circle" /> -->
                <i class="fa fa-3x fa-print text-info"></i>
              </mdb-avatar>
              <mdb-card-body>
                <h4 class="font-weight-bold  mb-3">Impresos Generales</h4>
                <p class="font-weight-bold text-info">
                  Fax / Copias, Tarjetas, Libretas de Facturas, Invitaciones,
                  Labels, Boletas, Logos, etc....
                </p>
                <a class="rotate-btn" @click="flipped_1 = true">
                  <mdb-icon class="pr-2" icon="redo" />ver más
                </a>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="face back " style="height: 416px;">
              <mdb-card-body
                class="pl-0 pr-0 scrollbar scrollbar-info pt-0 pb-0 bg-info"
              >
                <mdb-col class="scrollbar scrollbar-info pl-0 pr-0">
                  <h4
                    class="font-weight-bold bg-info pb-2 pt-3 pl-0 pr-0 text-white"
                  >
                    Más Impresos
                  </h4>
                  <!-- <hr /> -->
                  <ul
                    class="scrollbar scrollbar-info bg-white pt-3 text-left"
                    style="max-height: 300px; overflow-y: scroll; "
                  >
                    <li>Fax / Copias</li>
                    <li>Tarjetas de Presentación</li>
                    <li>Papel Carta (Stationary)</li>
                    <li>Sobres (diferentes tamaños)</li>
                    <li>Libretas de Facturas</li>
                    <li>Recetarios</li>
                    <li>Cartulinas</li>
                    <li>
                      Labels (Individuales o en rollo) en 1 Color o en Full
                      Color
                    </li>
                    <li>
                      Invitaciones
                      <ul>
                        <li>Bodas</li>
                        <li>Quinceañeros</li>
                        <li>Aniversarios</li>
                        <li>Confirmaciones</li>
                        <li>Expresiones de Gratitud</li>
                      </ul>
                    </li>
                    <li>
                      Programas
                      <ul>
                        <li>Graduaciones</li>
                        <li>Eventos</li>
                      </ul>
                    </li>
                    <li>Hojas de Promoción</li>
                    <ul>
                      <li>Hojas de Especiales</li>
                      <li>Posters</li>
                      <li>Hojas Sueltas (Flyers)</li>
                      <li>Diferentes Tamaños</li>
                    </ul>
                    <li>
                      Boletos
                      <ul>
                        <li>Rifas</li>
                        <li>Taquillas</li>
                        <li>Multas</li>
                        <li>Tickets de Estacionamiento</li>
                      </ul>
                    </li>
                    <li>Cheques Personalizados</li>
                    <li>Almanaques en diferentes tamaños</li>
                  </ul>
                  <a
                    class="rotate-btn bg-info text-white"
                    @click="flipped_1 = false"
                  >
                    <mdb-icon class="pr-2" icon="undo" />Volver
                  </a>
                </mdb-col>
              </mdb-card-body>
            </mdb-card>
          </mdb-flipping-card>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-6 mt-2">
          <mdb-flipping-card
            :flipped="flipped_3"
            innerClass="text-center h-100 w-100"
            style="height: 416px;"
          >
            <mdb-card class="face front" style="height: 416px;">
              <mdb-avatar class="mx-auto white mt-4" circle>
                <i class="fa fa-3x fa-flag text-info"></i>
                <!-- <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(20).jpg" class="rounded-circle" /> -->
              </mdb-avatar>
              <mdb-card-body>
                <h4 class="font-weight-bold mb-3">Rótulos</h4>
                <p class="font-weight-bold text-info">
                  Cruzacalles D-boards, Microperforado, Rotulatión Completa
                  (Full Wrap), Impresos en Camisetas etc....
                </p>
                <a class="rotate-btn" @click="flipped_3 = true">
                  <mdb-icon class="pr-2" icon="redo" />ver más
                </a>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="face back " style="height: 416px;">
              <mdb-card-body
                class="pl-0 pr-0 scrollbar scrollbar-info pt-0 pb-0 bg-info"
              >
                <mdb-col class="pl-0 pr-0">
                  <h4
                    class="font-weight-bold bg-info pb-2 pt-3 pl-0 pr-0 text-white"
                  >
                    Rotulación
                  </h4>
                  <!-- <hr /> -->
                  <!-- <ul class="scrollbar scrollbar-info bg-white" style="max-height: 300px; overflow-y: scroll; "> -->
                  <ul
                    class="scrollbar scrollbar-info bg-white mt-3 pt-3 text-left"
                    style="max-height: 300px; overflow-y: scroll; "
                  >
                    <li>Stickers</li>
                    <li>
                      Cruzacalles
                      <ul>
                        <li>Identificar su Negocio</li>
                        <li>Todo Tipo de Eventos</li>
                        <li>Diferentes Tamaños Disponibles</li>
                      </ul>
                    </li>
                    <li>Stand Banner</li>
                    <ul>
                      <li>Varilla</li>
                      <li>Roll-Up</li>
                    </ul>
                    <li>
                      D-boards
                      <ul>
                        <li>Vinil Cortado</li>
                        <li>Color</li>
                      </ul>
                    </li>
                    <li>Cutouts a Color</li>
                    <li>
                      PVC
                      <ul>
                        <li>Diferentes Grosores</li>
                        <li>Vinil Cortado</li>
                        <li>Pintado a Color</li>
                      </ul>
                    </li>
                    <li>
                      Microperforados
                      <ul>
                        <li>Autos</li>
                        <li>Oficinas</li>
                      </ul>
                    </li>
                    <li>
                      Rotulación Completa (Full Wrap)
                      <ul>
                        <li>Oficinas</li>
                        <li>Autos</li>
                        <li>Botes</li>
                      </ul>
                    </li>
                    <li>Pegatinas para Piso</li>
                    <li>Impresos en Camisas (transfer) Plancha de Calor</li>
                  </ul>
                  <a
                    class="rotate-btn bg-info text-white"
                    @click="flipped_3 = false"
                  >
                    <mdb-icon class="pr-2" icon="undo" />Volver
                  </a>
                </mdb-col>
              </mdb-card-body>
            </mdb-card>
          </mdb-flipping-card>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-12 mt-2">
          <mdb-flipping-card
            :flipped="flipped_2"
            innerClass="text-center h-100 w-100"
            style=" height: 416px;"
          >
            <mdb-card class="face front" style="height: 416px;">
              <mdb-avatar class="mx-auto white mt-4" circle>
                <i class="fa fa-3x fa-stamp text-info"></i>
                <!-- <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(20).jpg" class="rounded-circle" /> -->
              </mdb-avatar>
              <mdb-card-body>
                <h4 class="font-weight-bold mb-3">Sellos de Goma</h4>
                <p class="font-weight-bold text-info">
                  Contamos con Sellos regulares en madera, Pre-Entintados, en
                  diferentes tamaños.
                </p>
                <a class="rotate-btn" @click="flipped_2 = true">
                  <mdb-icon class="pr-2" icon="redo" />ver más
                </a>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="face back " style="height: 416px;">
              <mdb-card-body
                class="pl-0 pr-0 scrollbar scrollbar-info pt-0 pb-0 bg-info"
              >
                <mdb-col class="scrollbar scrollbar-info">
                  <h4
                    class="font-weight-bold bg-info pb-2 pt-3 pl-0 pr-0 text-white"
                  >
                    Sellos de Goma
                  </h4>
                  <!-- <hr /> -->
                  <!-- <ul class="scrollbar scrollbar-info bg-white" style="max-height: 300px; overflow-y: scroll; "> -->
                  <p class="text-white">
                    Los sellos son preparados Lunes, Miércoles y Viernes. Los
                    sellos digitales, (preparados en computadora) podemos
                    tenerlo en 15 minutos. *Ciertas restricciones aplican
                  </p>
                  <a
                    class="rotate-btn bg-info text-white"
                    @click="flipped_2 = false"
                  >
                    <mdb-icon class="pr-2" icon="undo" />Volver
                  </a>
                </mdb-col>
              </mdb-card-body>
            </mdb-card>
          </mdb-flipping-card>
        </div>
      </div>
    </mdb-container>
    <hr />
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbCol,
  mdbCard,
  mdbCardBody,
  // mdbCardUp,
  mdbIcon,
  mdbFlippingCard,
  mdbAvatar,
} from "mdbvue";

export default {
  name: "CardAnimationsPage",
  components: {
    mdbContainer,
    mdbCard,
    mdbCardBody,
    //   mdbCardUp,
    mdbIcon,
    mdbFlippingCard,
    mdbAvatar,
    mdbCol,
  },
  data() {
    return {
      flipped_1: false,
      flipped_2: false,
      flipped_3: false,
    };
  },
};
</script>

<style lang="css">
a.bg-info:hover,
a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: transparent !important;
}

/* .scrollbar {
    float: left;
    height: 300px;
    width: 150px;
    background: #fff;
    overflow-y: scroll;
    margin-bottom: 25px;
  } */

.scrollbar-primary::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-primary::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #4285f4;
}

.scrollbar-danger::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-danger::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-danger::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #ff3547;
}

.scrollbar-warning::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-warning::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-warning::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #ff8800;
}

.scrollbar-success::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-success::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-success::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #00c851;
}

.scrollbar-info::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-info::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-info::-webkit-scrollbar-thumb {
  /* border-radius: 10px; */
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #33b5e5;
}

.scrollbar-default::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-default::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-default::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #2bbbad;
}

.scrollbar-secondary::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.scrollbar-secondary::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.scrollbar-secondary::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #aa66cc;
}
</style>
